import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ClerkProvider } from "@clerk/clerk-react";

// Sentry Integration for Error Monitoring
// Commented out for now - install @sentry/react if needed
// const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
// if (SENTRY_DSN) {
//   import('@sentry/react').then((Sentry) => {
//     Sentry.init({
//       dsn: SENTRY_DSN,
//       integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration(),
//       ],
//       tracesSampleRate: 0.1,
//       replaysSessionSampleRate: 0.1,
//       replaysOnErrorSampleRate: 1.0,
//       environment: process.env.NODE_ENV || 'production',
//     });
//     console.log('✅ Sentry initialized for frontend monitoring');
//   }).catch(err => {
//     console.warn('⚠️ Sentry not available:', err);
//   });
// }

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      appearance={{
        elements: {
          rootBox: "mx-auto",
        },
      }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
